import { registerDe } from '../i18n/index.js';

registerDe({}, 'ConfirmModal'); // the verbs it uses live in the shared vocabulary (common.de.ts)
